import { format as formatDate } from 'date-fns';
import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Text } from 'roo-ui/components';
import ContentRow from 'pages/BookingConfirmation/ContentRow';
import ContentWrapper from 'pages/BookingConfirmation/ContentWrapper';
import { DISPLAY_DATE_FORMAT } from 'config';
import { getBookingReference, getStayDates } from 'store/booking/bookingSelectors';

const StaySummary = () => {
  const { checkIn, checkOut } = useSelector(getStayDates) || {};
  const bookingReference = useSelector(getBookingReference);

  const formattedCheckIn = formatDate(new Date(checkIn), DISPLAY_DATE_FORMAT);
  const formattedCheckOut = formatDate(new Date(checkOut), DISPLAY_DATE_FORMAT);

  return (
    <ContentWrapper pt={[6, 0]} mb={6}>
      <ContentRow>
        <Box width={[0.5, 0.2]} data-print-style="content-row-heading">
          <Text fontSize={['sm', 'base']}>Check-in date</Text>
        </Box>
        <Box>
          <Text fontSize={['sm', 'base']} data-testid="check-in-date" fontWeight="bold">
            {formattedCheckIn}
          </Text>
        </Box>
      </ContentRow>

      <ContentRow>
        <Box width={[0.5, 0.2]} data-print-style="content-row-heading">
          <Text fontSize={['sm', 'base']}>Check-out date</Text>
        </Box>
        <Box>
          <Text fontSize={['sm', 'base']} data-testid="check-out-date" fontWeight="bold">
            {formattedCheckOut}
          </Text>
        </Box>
      </ContentRow>

      <ContentRow display={['none', 'flex']} flexDirection="row" justifyContent={['space-between', 'flex-start']}>
        <Box width={[0.5, 0.2]} data-print-style="content-row-heading">
          <Text fontSize={['sm', 'base']}>Booking reference</Text>
        </Box>
        <Box>
          <Text fontSize={['sm', 'base']} data-testid="booking-reference">
            {bookingReference}
          </Text>
        </Box>
      </ContentRow>
    </ContentWrapper>
  );
};

StaySummary.displayName = 'StaySummary';

export default StaySummary;
